import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cswuxgoe1w: FaireBrandEntity = {
  token: "b_cswuxgoe1w",
  type: "brand",
  name: "Bona Furtuna",
  avatarUrl: "https://cdn.faire.com/fastly/371658ef8228a2089c12c4fce88a4d59b9900ac60cd830753de35bb9f62ef74b.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/d8b985e479b8d2d6d3e9a7e3e32bccde9b548aecc409fee4e86f86ddd9e736a7.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/371658ef8228a2089c12c4fce88a4d59b9900ac60cd830753de35bb9f62ef74b.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/d8b985e479b8d2d6d3e9a7e3e32bccde9b548aecc409fee4e86f86ddd9e736a7.jpeg",
  location: "Jackson, WY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description: "Founded on the verdant slopes of Sicily’s Monti Sicani mountain range, Bona Furtuna is dedicated to producing, sourcing and promoting the highest quality organic heirloom ingredients and cuisines from Italy. Bona Furtuna focuses on minimal processing to highlight the flavors of each Italian heirloom ingredient used to create our products. Transparency of organic, agricultural and production practices in concert with our efforts towards environmental stewardship and social responsibility adds value when purchasing our products. We continue these efforts as a sustaining member of 1% for the Planet, a Certified B Corporation and Climate Neutral Certified. With Bona Furtuna, you receive award-winning Italian products and the comfort of knowing our brand is working towards a more sustainable future.",
  meta: {
    source: "api",
    importedAt: "2026-10-09T07:53:33.527Z",
    importedBy: "entity-db-cli"
  }
};
